export const ASSETS_URL =
  "https://viralrathod.in/national-reliable-care-at-home/server/images";
// export const ASSETS_URL = "http://localhost/national-reliable-care-at-home-server/images";
export const APP_STORAGE = {
  layout: "layout/read.php",
  blog: "blogs/readAll.php",
  sale: "sales/create.php",
  product: "products/readAll.php",
  filterBlog: "blogs/filter.php",
  filterProduct: "products/filter.php",
  comment: "blogs/update.php",
  mail: "send_mail.php",
  imageUpload: "blogs/upload_image.php"
};
